import React from "react";
import { NavLink } from "react-router-dom";
import classes from "./NavItem.module.css";

type NavItemProps = {
    path: string;
};

const NavItem: React.FC<NavItemProps> = (props) => {
    return (
        <li className={classes.NavItem}>
            <NavLink to={props.path} exact activeClassName={classes.active}>
                <div className={classes.selected}></div>
                {props.children}
            </NavLink>
        </li>
    );
};

export default NavItem;
